const checkboxDropdown = function ($) {
    class CheckboxDropdown {
        constructor(el) {
            this.isOpen = false;
            this.$el = $(el);
            this.$label = this.$el.find('.dropdown-label');
            this.$inputs = this.$el.find('[type="checkbox"]');
            this.$dropdownList = this.$el.find('.dropdown-list');

            this.onCheckBox();

            this.$label.on('click', (e) => {
                e.preventDefault();
                this.closeAll();
                this.toggleOpen();
            });

            $(document).on('change', '.dropdown-option input[type="checkbox"]', () => this.onCheckBox());

            $(document).on('click', (e) => {
                if (this.isOpen && !$(e.target).closest(this.$el).length) {
                    this.toggleOpen();
                }
            });
        }

        onCheckBox() {
            this.updateStatus();
        }

        updateStatus() {
            const checked = this.$el.find(':checked');
            if (checked.length <= 0) {
                const label = this.$label.attr('data-label');
                this.$label.html(label);
            } else if (checked.length === 1) {
                this.$label.html(checked.parent('label').text());
            } else if (checked.length === this.$inputs.length) {
                this.$label.html('All Selected');
            } else {
                this.$label.html(`${checked.length} Selected`);
            }
        }

        toggleOpen(forceOpen) {
            if (!this.isOpen || forceOpen) {
                this.isOpen = true;
                this.$el.addClass('on');
                this.$dropdownList.removeAttr('hidden');
            } else {
                this.isOpen = false;
                this.$el.removeClass('on');
                this.$dropdownList.attr('hidden', 'hidden');
            }
        }

        closeAll() {
            this.$el.siblings().removeClass('on').find('.dropdown-list').attr('hidden', 'hidden');
        }
    }

    document.querySelectorAll('[data-control="checkbox-dropdown"]').forEach(el => new CheckboxDropdown(el));
};

export default checkboxDropdown;
